import GoogleAnalytics from "./ga";
import YaCounter from "./ym";

let ym = new YaCounter();
$(document).on('click', '[data-yagoal]', function () {
	ym.goal($(this).data('yagoal'));
});
$(document).on('submit-success', 'form[data-form-yagoal]', function () {
	ym.goal($(this).data('form-yagoal'));
});

let ga = new GoogleAnalytics();
$(document).on('click', '[data-gagoal]', function () {
	ga.goal($(this).data('gagoal'));
});
$(document).on('submit-success', 'form[data-form-gagoal]', function () {
	ga.goal($(this).data('form-gagoal'));
});
